import { PublicClientApplication } from '@azure/msal-browser'

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

// Scope for your backend API.
// Must match the scope registered in Azure → App Registration → "Expose an API"
export const loginRequest = {
  scopes: [process.env.REACT_APP_AZURE_SCOPE],
}

// Single shared instance — initialised in index.js before the React tree mounts
export const msalInstance = new PublicClientApplication(msalConfig)
